var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9999 1.5999C3.9999 0.937161 4.53716 0.399902 5.1999 0.399902C5.86264 0.399902 6.3999 0.937161 6.3999 1.5999V2.7999H13.5999V1.5999C13.5999 0.937161 14.1372 0.399902 14.7999 0.399902C15.4626 0.399902 15.9999 0.937161 15.9999 1.5999V2.7999H17.1999C18.5254 2.7999 19.5999 3.87442 19.5999 5.1999V17.1999C19.5999 18.5254 18.5254 19.5999 17.1999 19.5999H2.7999C1.47442 19.5999 0.399902 18.5254 0.399902 17.1999V5.1999C0.399902 3.87442 1.47442 2.7999 2.7999 2.7999H3.9999V1.5999ZM13.0761 8.53462C12.681 8.12437 12.0282 8.11205 11.618 8.50711C11.2077 8.90217 11.1954 9.555 11.5904 9.96526L12.0752 10.4687L5.49994 10.4687C4.9304 10.4687 4.46869 10.9304 4.46869 11.4999C4.46869 12.0695 4.9304 12.5312 5.49994 12.5312L12.0752 12.5312L11.5904 13.0346C11.1954 13.4449 11.2077 14.0977 11.618 14.4928C12.0282 14.8878 12.681 14.8755 13.0761 14.4653L15.2428 12.2153C15.6273 11.8159 15.6273 11.184 15.2428 10.7846L13.0761 8.53462Z",
    fill: "#399B6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarRightArrow);
export default __webpack_public_path__ + "static/media/calendar-right-arrow.8f49cdbc8eeeeba1d198952d4851014e.svg";
export { ForwardRef as ReactComponent };